import {
  Card as ChakraCard,
  CardHeader,
  CardBody,
  CardFooter,
  Text,
  Flex,
  Icon,
} from '@chakra-ui/react';

type Props = {
  studentName: string;
  HeaderIcon: React.ElementType;
  Footer: React.ReactNode;
  headerText: string;
  courseTitle: string;
  courseIdentifier: string | null;
  progressWeeks?: number;
};

export default function Card({
  studentName,
  headerText,
  HeaderIcon,
  Footer,
  courseTitle,
  courseIdentifier,
}: Props) {
  return (
    <ChakraCard
      variant="unstyled"
      borderRadius="2xl"
      backgroundColor="bg.subtle"
      w={'full'}
      gap="2"
      px={3}
      py={2}
    >
      <CardHeader p={0}>
        <Flex justify="space-between" align="end">
          <Text
            fontSize="xs"
            fontWeight="semibold"
            color="fg.subtle"
            isTruncated
            whiteSpace="nowrap"
          >
            {studentName}
          </Text>
          <Flex align="center" gap={1} whiteSpace="nowrap">
            <Icon as={HeaderIcon} boxSize={4} color="fg.subtle" />
            <Text fontSize="xs" color="fg.subtle">
              {headerText}
            </Text>
          </Flex>
        </Flex>
      </CardHeader>

      <CardBody p={0}>
        <Flex justify="space-between" align="top">
          <Text fontSize="xs" color="fg.subtle" flex="1" isTruncated whiteSpace="nowrap">
            {courseTitle}
          </Text>
          <Text fontSize="xs" color="fg.disabled" whiteSpace="nowrap" ml={2}>
            {courseIdentifier}
          </Text>
        </Flex>
      </CardBody>

      <CardFooter p={0}>
        <Flex w="100%" justify="space-between" align="center">
          {Footer}
        </Flex>
      </CardFooter>
    </ChakraCard>
  );
}
